import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Lozenge from '~/components/atoms/Lozenge/Lozenge'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'

import LozengeList from '../LozengeList/LozengeList'

import styles from './TeamExpertiseList.module.css'

export interface TeamExpertiseListProps {
  _id?: string
  theme?: ComponentTheme
  featuredTopics?: any[]
  teamMemberName: string
}

export default function TeamExpertiseList({
  theme = ComponentTheme.primary,
  teamMemberName,
  featuredTopics,
}: TeamExpertiseListProps) {
  return (
    <Fixture theme={theme}>
      <div className={styles.featuredTopics}>
        <Container>
          <div className={styles.titleWithBorder}>
            <Text size={TextSizes.primaryTitleLrg}>Topic Exterptise</Text>
          </div>
          <LozengeList>
            {featuredTopics?.map(topic => (
              <Lozenge
                title={topic.name}
                link={`/articles?author=${teamMemberName}&filter=${topic.slug}#all-articles`}
                count={''}
                key={`topic-expertise-${topic._ref}`}
              />
            ))}
          </LozengeList>
        </Container>
      </div>
    </Fixture>
  )
}
